import React, { useState, useEffect } from 'react'
import { Box, Radio, RadioGroup, Stack, Text, Input } from '@chakra-ui/react'

interface ScaleCardProps {
  readOnly?: boolean
  value?: number | null
  onChange?: (value: number) => void
  questionId?: string
  onRatingSelect?: (questionId: string, rating: number) => void
  isIndividualResponse?: boolean
  quizMode?: boolean
}

const ScaleCard: React.FC<ScaleCardProps> = ({
  readOnly = false,
  value = null,
  onChange,
  questionId = '',
  onRatingSelect,
  isIndividualResponse = false,
  quizMode = false,

}) => {
  const [rating, setRating] = useState<string>(value ? String(value) : '')
  const [lowLabel, setLowLabel] = useState<string>('Low')
  const [highLabel, setHighLabel] = useState<string>('High')

  const handleChange = (newValue: string) => {
    if (readOnly && isIndividualResponse) return

    setRating(newValue)
    const numValue = parseInt(newValue, 10)

    if (onChange) {
      onChange(numValue)
    }

    if (onRatingSelect && questionId) {
      onRatingSelect(questionId, numValue)
    }
  }

  useEffect(() => {
    if (value !== null && value !== undefined) {
      const ratingValue = String(value)
      setRating(ratingValue)
    }
  }, [value])

  return (
    <Box className="scale-card" px="20px">
      <Stack direction="row" justify="space-between" align="center">
        <Input
          value={lowLabel}
          onChange={(e) => setLowLabel(e.target.value)}
          width={["5.5ch", "8ch", "10ch"]} 
          minWidth="7ch"
          maxWidth="10ch"
          size="sm"
          maxLength={10}
          isDisabled={quizMode || false}
          textStyle="l-s"
          bg="white"
          
        />

        <RadioGroup name="scale" value={rating} onChange={handleChange} isDisabled={readOnly && !isIndividualResponse}>
          <Stack direction="row" spacing="40px" align="center">
            {[1, 2, 3, 4, 5].map((scaleValue) => (
              <Box key={scaleValue} textAlign="center">
                <Text mb={1}>{scaleValue}</Text>
                <Radio
                  colorScheme={
                    isIndividualResponse ? 'primary' : rating === String(scaleValue) ? 'brand' : 'blackAlpha'
                  }
                  value={String(scaleValue)}
                  size="lg"
                  border="1px"
                  borderColor="solid.200"
                  isDisabled={readOnly && !isIndividualResponse}
                  cursor={readOnly ? 'default' : 'pointer'}
                  pointerEvents={isIndividualResponse ? 'none' : 'auto'}
                  isChecked={rating === String(scaleValue)}
                  {...(isIndividualResponse && rating === String(scaleValue)
                    ? {
                      bg: 'brand.100',
                      _checked: { bg: 'brand.100' },
                    }
                    : {})}
                />
              </Box>
            ))}
          </Stack>
        </RadioGroup>
       <Input
          value={highLabel}
          onChange={(e) => setHighLabel(e.target.value)}
          width={["5.5ch", "8ch", "10ch"]} 
          minWidth="5ch"
          maxWidth="10ch"
          size="sm"
          maxLength={10}
          isDisabled={quizMode || false}
          textStyle="l-s"
          bg="white"
        />
      </Stack>
    </Box>
  )
}

export default ScaleCard
